var _path, _circle, _path2, _path3, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3.3333,
    d: "M11.5,13.4v-3.1c0-2.1,1.6-3.9,3.5-3.9s3.5,1.7,3.5,3.9v3.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3.3333,
    cx: 15,
    cy: 15,
    r: 13.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.9,22.9H0v-12h6.9V22.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.7,13h10.5c0.8,0,1.5,0.7,1.5,1.6v5.7c0,0.9-0.7,1.6-1.5,1.6H9.7c-0.8,0-1.5-0.7-1.5-1.6v-5.7C8.2,13.7,8.9,13,9.7,13z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "currentColor",
    points: "9.3,10.9 0.3,10.9 0.3,1.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.c94ad1c6b9d3fc56c049a14aad68e5b0.svg";
export { ForwardRef as ReactComponent };